'use client'

import { useState, ChangeEvent, FormEvent } from 'react'
import Dialog from '@/components/ui/Dialog'
import Button from '@/components/ui/Button'
import { Input, Checkbox, FormItem } from '@/components/ui'
import Link from 'next/link'
import { PiCheckBold } from 'react-icons/pi'

interface CallbackModalProps {
    isOpen: boolean
    onClose: () => void
}

type Errors = Partial<Record<keyof typeof form, string>>
const CallbackModal = ({ isOpen, onClose }: CallbackModalProps) => {
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)

    const phoneRegex = /^\+7/

    const validate = () => {
        if (
            !form.company.trim() ||
            !form.name.trim() ||
            !phoneRegex.test(form.phone) ||
            !form.agree
        ) {
            setError(true)
            return false
        }

        setError(false)
        return true
    }

    const [form, setForm] = useState({
        company: '',
        name: '',
        phone: '+7',
        message: '',
        agree: false,
    })

    const onChange = (
        e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        const { name, value } = e.target
        setForm((prev) => ({ ...prev, [name]: value }))
    }

    const onSubmit = (e: FormEvent) => {
        e.preventDefault()

        if (!validate()) {
            setError(true)
            return
        }

        setError(false)

        console.log(form)

        setSuccess(true)
    }

    return (
        <Dialog isOpen={isOpen} onClose={onClose} width={520}>
            <div className="p-6">
                {!success ? (
                    <>
                        <h2 className="text-2xl font-semibold text-gray-800 mb-2">
                            Заказать обратный звонок
                        </h2>

                        <form onSubmit={onSubmit} className="space-y-4">
                            <FormItem
                                label="Название компании"
                                invalid={error}
                                errorMessage={
                                    'Введите название вашей организации'
                                }
                            >
                                <Input
                                    name="company"
                                    value={form.company}
                                    onChange={onChange}
                                    placeholder="ООО «МаркетСИЗ»"
                                />
                            </FormItem>

                            <FormItem
                                label="ФИО"
                                invalid={error}
                                errorMessage={'Введите ваше ФИО'}
                            >
                                <Input
                                    name="name"
                                    value={form.name}
                                    onChange={onChange}
                                    placeholder="Иванов Иван Иванович"
                                />
                            </FormItem>

                            <FormItem
                                label="Контактный телефон"
                                invalid={error}
                                errorMessage={
                                    'Введите номер в формате +79999999999 без пробелов'
                                }
                            >
                                <Input
                                    name="phone"
                                    value={form.phone}
                                    onChange={onChange}
                                    prefix={<span className="text-sm">🇷🇺</span>}
                                    placeholder="+7 (___) ___-__-__"
                                />
                            </FormItem>

                            <FormItem label="Сообщение">
                                <Input
                                    textArea
                                    rows={4}
                                    name="message"
                                    value={form.message}
                                    onChange={onChange}
                                    placeholder="Комментарий или удобное время для звонка"
                                />
                            </FormItem>

                            <FormItem invalid={error}>
                                <label className="flex gap-3 items-start text-sm">
                                    <Checkbox
                                        checked={form.agree}
                                        onChange={(checked) =>
                                            setForm((prev) => ({
                                                ...prev,
                                                agree: checked,
                                            }))
                                        }
                                    />
                                    <span>
                                        Я даю согласие на обработку персональных
                                        данных в соответствии с{' '}
                                        <Link href="/policy" className="underline">
                                            Политикой конфиденциальности
                                        </Link>
                                    </span>
                                </label>
                            </FormItem>

                            <Button
                                type="submit"
                                className="flex gap-2 items-center justify-center w-full h-14 rounded-xl px-8 py-2 text-base bg-second text-white hover:bg-second-light"
                            >
                                Заказать звонок
                            </Button>
                        </form>
                    </>
                ) : (
                    <div className="bg-white  p-8 max-w-md text-center px-4 py-5">
                        <div className="flex justify-center mb-4">
                            <PiCheckBold size={48} className="text-second" />
                        </div>
                        <h3 className="text-2xl font-semibold text-gray-800 mb-2">
                            Спасибо!
                        </h3>
                        <p className="text-gray-600 mb-6">
                            Мы свяжемся с вами в ближайшее время
                        </p>

                        <div className="flex gap-2 items-center justify-center">
                            <Button
                                onClick={onClose}
                                className=" h-14 rounded-xl px-8 py-2 text-base bg-primary text-white hover:bg-pimary-hover"
                            >
                                Закрыть
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </Dialog>
    )
}

export default CallbackModal
